
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import '../../DashboardWithdraw.less';
import './DashboardWithdrawRecord.less';
import { WITHDRAW_HISTORY } from '../../DashboardWithdraw.gql';
import { useLazyQuery } from '@apollo/client';
import { Space } from 'antd';
import { format } from "date-fns";
import NumberFormat from 'react-number-format';
import ItemListPagination from '../../../../shared/components/item-list/ItemListPagination';

interface Props {
	startDate: any;
	endDate: any;
	pagination?: boolean;
	isTrigger?: boolean;
}

const DashboardWithdrawRecord = ({ startDate, endDate, pagination = true, isTrigger=false }: Props) => {
	const intl = useIntl();
	const [pageNo, setPageNo] = useState<number>(1);
	const pageSize = process.env.REACT_APP_PAGE_SIZE ? +process.env.REACT_APP_PAGE_SIZE : 10;
	const [total, setTotal] = useState<number>(0);
	const [reportData, setReportData] = useState<any>();
	const [getWithdrawHistory, { data: withdrawHistoryData }] = useLazyQuery(WITHDRAW_HISTORY,
		{ fetchPolicy: "cache-and-network" });

	useEffect(() => {
		if (isTrigger) {
			getWithdrawHistory({
				variables: {
					pageNo: pageNo, pageSize: pageSize, topTen: !pagination, historyInput: {
						startDate: startDate,
						endDate: endDate
					}
				}
			});
		}// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isTrigger, pageNo, pageSize])

	useEffect(() => {
		if (withdrawHistoryData && withdrawHistoryData.withdrawHistory && withdrawHistoryData.withdrawHistory.count && withdrawHistoryData.withdrawHistory.affiliateWithdrawals) {
			const withdrawData = withdrawHistoryData.withdrawHistory && withdrawHistoryData.withdrawHistory.affiliateWithdrawals.length > 0 ?
				withdrawHistoryData.withdrawHistory.affiliateWithdrawals.map((val: any) => {
					return {
						...val,
						key: val.id
					};
				}) : [];
			setReportData(withdrawData);
			setTotal(withdrawHistoryData.withdrawHistory.count);
		}
	}, [withdrawHistoryData])

	const columns: any = [
		{
			title: intl.formatMessage({ id: 'DASHBOARD_TRANSACTION_DATE' }),
			dataIndex: 'createdAt',
			render: (text: any) => {
				return (
					<Space size="middle">
						{
							(text) ?
								format(new Date(text), "yyyy-MM-dd HH:mm") :
								'-'
						}
					</Space>
				)
			}
		}, {
			title: intl.formatMessage({ id: 'DASHBOARD_APPROVED_DATE' }),
			dataIndex: 'approvedAt',
			render: (text: any) => {
				return (
					<Space size="middle">
						{
							(text) ?
								format(new Date(text), "yyyy-MM-dd HH:mm") :
								'-'
						}
					</Space>
				)
			}
		}, {
			title: intl.formatMessage({ id: 'DASHBOARD_TRANSACTION_AMT' }),
			dataIndex: 'amount',
			render: (text: any) => {
				return (
					<Space size="middle">
						{
							(text) ?
								<NumberFormat
									value={parseFloat(text).toFixed(2)}
									displayType={"text"}
									thousandSeparator={true}
									fixedDecimalScale
									decimalScale={2}
								/> :
								'-'
						}
					</Space>
				)
			}
		}, {
			title: intl.formatMessage({ id: 'DASHBOARD_TRANSACTION_METHOD' }),
			dataIndex: 'bankAccount',
			render: (text: any) => {
				return (
					<Space size="middle">
						{
							(text && text.withdrawalMethod) ?
								<FormattedMessage id={`DASHBOARD_WITHDRAW_METHOD_${text.withdrawalMethod}`} /> :
								'-'
						}
					</Space>
				)
			},
		}, {
			title: intl.formatMessage({ id: 'DASHBOARD_TRANSACTION_STATUS' }),
			dataIndex: 'status',
			render: (text: any) => {
				return (
					<Space size="middle">
						{
							(text) ?
								<FormattedMessage id={`DASHBOARD_WITHDRAW_STATUS_${text}`} /> :
								'-'
						}
					</Space>
				)
			},
		},
	]

	return (
		<div className="dashboard-withdraw-record">
			<ItemListPagination pageNo={pageNo} pageSize={pageSize} setPageNo={setPageNo} columns={columns} data={reportData || []}
				total={total} />
		</div>
	)
}

export default DashboardWithdrawRecord;